/*
 * Copyright © 2023 Broadcom. All rights reserved. The term “Broadcom” refers to Broadcom Inc. and/or its subsidiaries. All trademarks, trade names, service marks, and logos referenced herein belong to their respective companies.
 * This software and all information contained therein is confidential and proprietary and shall not be duplicated, used, disclosed or disseminated in any way except as authorized by the applicable license agreement, without the express written permission of Broadcom. All authorized reproductions must be marked with this language.
 * EXCEPT AS SET FORTH IN THE APPLICABLE LICENSE AGREEMENT, TO THE EXTENT PERMITTED BY APPLICABLE LAW OR AS AGREED BY BROADCOM IN ITS APPLICABLE LICENSE AGREEMENT, BROADCOM PROVIDES THIS DOCUMENTATION “AS IS” WITHOUT WARRANTY OF ANY KIND, INCLUDING WITHOUT LIMITATION, ANY IMPLIED WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE, OR NONINFRINGEMENT. IN NO EVENT WILL BROADCOM BE LIABLE TO THE END USER OR ANY THIRD PARTY FOR ANY LOSS OR DAMAGE, DIRECT OR INDIRECT, FROM THE USE OF THIS DOCUMENTATION, INCLUDING WITHOUT LIMITATION, LOST PROFITS, LOST INVESTMENT, BUSINESS INTERRUPTION, GOODWILL, OR LOST DATA, EVEN IF BROADCOM IS EXPRESSLY ADVISED IN ADVANCE OF THE POSSIBILITY OF SUCH LOSS OR DAMAGE.
 */
class Poller {
  constructor(pollFunc, opts = {}) {
    if (!pollFunc) {
      throw Error('Poller: you must provide a function to poll')
    }
    this.tm = null
    this.pollFunc = pollFunc
    this.timeout = opts.timeout || (30*1000)
    this.pollFailure = opts.pollFailure || (() => {})
    this.pollSuccess = opts.pollSuccess || (() => {})
  }
  poll = () => {
    if (this.tm) {
      return this
    }
    this.tm = setTimeout(() => {
      this.pollFunc()
        .then(this._pollSuccess, this._pollFailure)
      }, this.timeout)
    return this
  }
  _pollFailure = (e, ...rest) => {
    if (!this.tm) {
      return this
    }
    console.error('Poller: unable to poll on provided function', e)
    this.tm = null
    this.poll()
    this.pollFailure.apply(null, [e, ...rest])
  }
  _pollSuccess = (...args) => {
    if (!this.tm) {
      return this
    }
    this.tm = null
    this.poll()
    this.pollSuccess.apply(null, args)
  }
  start = () => {
    this.poll()
    return this
  }
  stop = () => {
    clearTimeout(this.tm)
    this.tm = null
    return this
  }
}

export default ((pollFunc, opts) => {
  return new Poller(pollFunc, opts)
})
